import {FC, useCallback} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {AdminHeader} from "../../AdminHeader";
import useDevCycleSdk from "@/hooks/useDevCycleSdk";
import { AdminLessonsTable } from "@/components/admin/lessonTable/AdminLessonsTable";

const useStyles = makeStyles()((_theme) => ({
	adminLessonsList: {
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		}
	}
}));

export const AdminLessonsList: FC = () => {
	const {classes} = useStyles();
	const navigate = useNavigate();
	const {hideCreationButtons, contentCreationUpdates} = useDevCycleSdk();

	const onCreateClick = useCallback(() => {
		if(contentCreationUpdates) {
			navigate("create-new");
		} else {
			navigate("create");
		}
	}, [contentCreationUpdates, navigate]);

	return (
		<Box className={classes.adminLessonsList}>
			<AdminHeader
				title="Lessons"
				subtitle="Manage lessons"
				actionButtons={hideCreationButtons ? undefined : [{label: "Create New", onClick: onCreateClick}]}
			/>
			<AdminLessonsTable />
		</Box>
	);
}
